import { Injectable } from '@angular/core'; // O React Hook
import { AuthSession } from '../../shared/models/auth.model';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
  private currentSession: AuthSession | null = null;

  loadSession(session: AuthSession) {
    this.currentSession = session;
  }

  hasPermission(requiredPerm: string): boolean {
    if (!this.currentSession?.security.permissions) {
      return false;
    }

    const myPermissions = this.currentSession.security.permissions;

    if (myPermissions.includes(requiredPerm)) {
      return true;
    }

    const resource = requiredPerm.split(':')[0];
    if (myPermissions.includes('*') || myPermissions.includes(`${resource}:*`)) {
      return true;
    }

    return false;
  }

  hasGlobalScope(): boolean {
    return this.currentSession?.security.scope === 'GLOBAL';
  }
}
